import mixpanel from 'mixpanel-browser';

const isProd = import.meta.env.VITE_ENV === 'production';
export const mixpanelToken = import.meta.env.VITE_MIXPANEL_TOKEN;

// Helper to check if Mixpanel is properly configured
export const isMixpanelEnabled = (): boolean => {
  return isProd && !!mixpanelToken;
};

// Initialize Mixpanel
if (isMixpanelEnabled()) {
  mixpanel.init(mixpanelToken, {
    debug: !isProd,
    track_pageview: true,
    persistence: 'localStorage',
  });
}

// Track event helper
export const track = (eventName: string, properties?: Record<string, any>) => {
  if (!isMixpanelEnabled()) return;
  mixpanel.track(eventName, properties);
};

// Identify user helper
export const identifyUser = (
  user_id: string,
  email: string,
  org_id: string,
  name: string
) => {
  if (!isMixpanelEnabled()) return;
  mixpanel.identify(user_id);
  mixpanel.people.set({
    $email: email,
    $name: name,
    org_id: org_id,
  });
};

// Reset user helper
export const resetUser = () => {
  if (!isMixpanelEnabled()) return;
  mixpanel.reset();
};
